import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiTabs = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiTabs: {
      defaultProps: {},
      styleOverrides: {
        root: {
          height: spacing(6),
          minHeight: spacing(6),
        },
        indicator: {
          display: 'flex',
          justifyContent: 'center',
          height: '4px',
          backgroundColor: 'transparent',

          '&::after': {
            content: '""',
            width: '100%',
            maxWidth: spacing(6),
            height: '100%',
            borderRadius: '4px',
            backgroundColor: palette.dark.dark,
          },
        },
      },
    },
  }) satisfies ComponentCreation
